import { FunctionComponent } from 'react';
import { Field, FormikHelpers } from 'formik';
import { FieldInputProps } from 'formik/dist/types';
import {
    Checkbox,
    CheckboxProps,
    FormControlLabel,
    FormGroup,
} from '@mui/material';

type MaterialCheckboxProps = {
    form: FormikHelpers<boolean>;
    field: FieldInputProps<boolean>;
    label: string;
    disabled?: boolean;
    sx?: CheckboxProps['sx'];
};

const MaterialCheckbox: FunctionComponent<
    React.PropsWithChildren<MaterialCheckboxProps>
> = ({ label, form, field, disabled, sx }) => {
    const { name, value } = field;
    const { setFieldValue } = form;

    return (
        <FormGroup>
            <FormControlLabel
                sx={sx}
                control={
                    <Checkbox
                        checked={value}
                        onChange={(e) => {
                            setFieldValue(name, e.target.checked);
                        }}
                    />
                }
                label={label}
                disabled={disabled}
            />
        </FormGroup>
    );
};

type CheckboxFieldProps = {
    name: string;
    label: string;
    disabled?: boolean;
    sx?: CheckboxProps['sx'];
};

export const CheckboxField: FunctionComponent<
    React.PropsWithChildren<CheckboxFieldProps>
> = ({ name, ...props }) => {
    return (
        <Field name={name}>
            {({ field, form }) => (
                <MaterialCheckbox field={field} form={form} {...props} />
            )}
        </Field>
    );
};
